/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getUserLabTestItems } from 'app/entities/user-lab-test-item/user-lab-test-item.reducer';
import { getEntities as getLabTestItems } from 'app/entities/lab-test-item/lab-test-item.reducer';
import { getEntities as getBloodDonations } from 'app/entities/blood-donation/blood-donation.reducer';
import { getEntities as getBloodBanks } from 'app/entities/blood-bank/blood-bank.reducer';
import { getEntities as getBloodBankInventories } from 'app/entities/blood-bank-inventory/blood-bank-inventory.reducer';
import { createEntity, getEntity, reset, updateEntity } from './blood-inventory-investigation.reducer';

export const BloodInventoryInvestigationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const userLabTestItems = useAppSelector(state => state.userLabTestItem.entities);
  const labTestItems = useAppSelector(state => state.labTestItem.entities);
  const bloodDonations = useAppSelector(state => state.bloodDonation.entities);
  const bloodBanks = useAppSelector(state => state.bloodBank.entities);
  const bloodBankInventories = useAppSelector(state => state.bloodBankInventory.entities);
  const bloodInventoryInvestigationEntity = useAppSelector(state => state.bloodInventoryInvestigation.entity);
  const loading = useAppSelector(state => state.bloodInventoryInvestigation.loading);
  const updating = useAppSelector(state => state.bloodInventoryInvestigation.updating);
  const updateSuccess = useAppSelector(state => state.bloodInventoryInvestigation.updateSuccess);

  const handleClose = () => {
    navigate(`/blood-inventory-investigation${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUserLabTestItems({}));
    dispatch(getLabTestItems({}));
    dispatch(getBloodDonations({}));
    dispatch(getBloodBanks({}));
    dispatch(getBloodBankInventories({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...bloodInventoryInvestigationEntity,
      ...values,
      test: userLabTestItems.find(it => it.id.toString() === values.test?.toString()),
      baseTest: labTestItems.find(it => it.id.toString() === values.baseTest?.toString()),
      donation: bloodDonations.find(it => it.id.toString() === values.donation?.toString()),
      bank: bloodBanks.find(it => it.id.toString() === values.bank?.toString()),
      bloodBankInventory: bloodBankInventories.find(it => it.id.toString() === values.bloodBankInventory?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...bloodInventoryInvestigationEntity,
          test: bloodInventoryInvestigationEntity?.test?.id,
          baseTest: bloodInventoryInvestigationEntity?.baseTest?.id,
          donation: bloodInventoryInvestigationEntity?.donation?.id,
          bank: bloodInventoryInvestigationEntity?.bank?.id,
          bloodBankInventory: bloodInventoryInvestigationEntity?.bloodBankInventory?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.bloodInventoryInvestigation.home.createOrEditLabel"
            data-cy="BloodInventoryInvestigationCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.bloodInventoryInvestigation.home.createOrEditLabel">
              Create or edit a BloodInventoryInvestigation
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="blood-inventory-investigation-id"
                  label={translate('tinyMedicRestApp.bloodInventoryInvestigation.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodInventoryInvestigation.result')}
                id="blood-inventory-investigation-result"
                name="result"
                data-cy="result"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodInventoryInvestigation.observation')}
                id="blood-inventory-investigation-observation"
                name="observation"
                data-cy="observation"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodInventoryInvestigation.statusCode')}
                id="blood-inventory-investigation-statusCode"
                name="statusCode"
                data-cy="statusCode"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodInventoryInvestigation.limits')}
                id="blood-inventory-investigation-limits"
                name="limits"
                data-cy="limits"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodInventoryInvestigation.active')}
                id="blood-inventory-investigation-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodInventoryInvestigation.cursor')}
                id="blood-inventory-investigation-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodInventoryInvestigation.lastUpdated')}
                id="blood-inventory-investigation-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodInventoryInvestigation.microSec')}
                id="blood-inventory-investigation-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodInventoryInvestigation.timestampEntry')}
                id="blood-inventory-investigation-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="blood-inventory-investigation-test"
                name="test"
                data-cy="test"
                label={translate('tinyMedicRestApp.bloodInventoryInvestigation.test')}
                type="select"
              >
                <option value="" key="0" />
                {userLabTestItems
                  ? userLabTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-inventory-investigation-baseTest"
                name="baseTest"
                data-cy="baseTest"
                label={translate('tinyMedicRestApp.bloodInventoryInvestigation.baseTest')}
                type="select"
              >
                <option value="" key="0" />
                {labTestItems
                  ? labTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-inventory-investigation-donation"
                name="donation"
                data-cy="donation"
                label={translate('tinyMedicRestApp.bloodInventoryInvestigation.donation')}
                type="select"
              >
                <option value="" key="0" />
                {bloodDonations
                  ? bloodDonations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-inventory-investigation-bank"
                name="bank"
                data-cy="bank"
                label={translate('tinyMedicRestApp.bloodInventoryInvestigation.bank')}
                type="select"
              >
                <option value="" key="0" />
                {bloodBanks
                  ? bloodBanks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-inventory-investigation-bloodBankInventory"
                name="bloodBankInventory"
                data-cy="bloodBankInventory"
                label={translate('tinyMedicRestApp.bloodInventoryInvestigation.bloodBankInventory')}
                type="select"
              >
                <option value="" key="0" />
                {bloodBankInventories
                  ? bloodBankInventories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/blood-inventory-investigation"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BloodInventoryInvestigationUpdate;
